// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"128":"059560a2","890":"4ed8c68f"}[chunkId] + ".css";
};